import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorStepTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(980);
  const props = __props;

const __returned__ = { isDesktop, props, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})